import React from 'react'
import { Link } from 'react-router-dom'

import Tag from '../content/Tag'
import DateRow from '../layout/DateRow'
import LocationInfo from './LocationInfo'
import RsvpTag from './RsvpTag'
import ClickableCard from '../layout/ClickableCard'

type Props = {
  id: number
  title: string
  authors: string[]
  startDate: Date
  endDate: Date
  type: string
  location?: string
  streamingLink?: string
  rsvpStatus: boolean
}
const EventCard: React.FC<Props> = ({ id, title, location, authors, startDate, endDate, type, streamingLink, rsvpStatus }) => {
  const isPastEvent = new Date(endDate) < new Date()

  const content = (
    <DateRow startDate={startDate} endDate={endDate}>
      <div className={`flex flex-col sm:flex-row items-between gap-2 h-full ${isPastEvent ? 'opacity-50' : ''}`}>
        <div className='flex-1 flex flex-col justify-between gap-y-1 lg:gap-y-2'>
          <p className='text-xs sm:text-sm font-semibold line-clamp-2 sm:line-clamp-1'>{title}</p>
          <p className='font-light text-2xs sm:text-xs'>{authors.toString().replace(/,/g, ', ')}</p>
          <p className='text-2xs sm:text-xs line-clamp-2 sm:line-clamp-1'>
            <LocationInfo location={location} streamingLink={streamingLink} />
          </p>
        </div>
        <div className='inline-flex sm:flex-col justify-between'>
          <Tag border outlined transparent>{type.toUpperCase()}</Tag>
          {!!rsvpStatus && <RsvpTag />}
        </div>
      </div>
    </DateRow>
  )

  return (
    <ClickableCard disabled={isPastEvent}>
      {isPastEvent ? content : <Link to={`/events/${id}`}>{content}</Link>}
    </ClickableCard>
  )
}

export default EventCard
